<template>
  <div class="header" id="Header">
    <div class="header-content">
      <div class="logo">
        <a href="/" style="display: flex; align-items: center">
          <img class="image" src="../assets/images/logo.png" alt="" />
        </a>
      </div>
      <div class="login">
        <Nav />
        <!-- <a href="javascript:void(0)" @click="goWarn">登录</a>
        <a href="javascript:void(0)" @click="goWarn">注册</a> -->
      </div>
      <div class="search">
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="banner">
      <el-carousel
        v-if="this.$route.name && this.$route.name == 'home'"
        height="520px"
        arrow="never"
      >
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <a @click="more(item, '/news/list', item.nbId, true)">
            <img :style="item.cSign == 1 || item.nbId ? 'cursor: pointer;' : ''" class="image" :src="item.nbcImg" :alt="item.noticeTitle"
          /></a>
        </el-carousel-item>
      </el-carousel>
      <div class="s-banner" :style="bannerStyle" v-else>
        <div class="bannerTitle">
          <img
            class="title-image left"
            src="@/assets/images/title-left.png"
            alt=""
          />
          <span>{{ getBannerName(this.$route.params.id) }}</span>
          <img
            class="title-image right"
            src="@/assets/images/title-right.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectNoticeLarge } from "@/utils/api";
import Nav from "./Nav.vue";
export default {
  name: "Header",
  components: {
    Nav,
  },
  data() {
    return {
      bannerList: [],
      bannerStyle: {}
    };
  },
  // watch: {
  //   $route: {
  //     handler(val) {
  //       if (val.path.indexOf('introduction') > -1) {
  //         this.bannerStyle = {
  //           'background': `#e5e7f4 url(/images/banner-1.png) no-repeat center center`,
  //           'backgroundSize': 'cover'
  //         }
  //       } else if (val.path.indexOf('news') > -1) {
  //         this.bannerStyle = {
  //           'background': `#e5e7f4 url(/images/banner-2.png) no-repeat center center`,
  //           'backgroundSize': 'cover'
  //         }
  //       } else if (val.path.indexOf('expert') > -1) {
  //         this.bannerStyle = {
  //           'background': `#e5e7f4 url(/images/banner-3.png) no-repeat center center`,
  //           'backgroundSize': 'cover'
  //         }
  //       } else if (val.path.indexOf('kb') > -1) {
  //         this.bannerStyle = {
  //           'background': `#e5e7f4 url(/images/banner-4.png) no-repeat center center`,
  //           'backgroundSize': 'cover'
  //         }
  //       } else if (val.path.indexOf('centigrade') > -1) {
  //         this.bannerStyle = {
  //           'background': `#e5e7f4 url(/images/banner-5.png) no-repeat center center`,
  //           'backgroundSize': 'cover'
  //         }
  //       }
  //     },
  //     immediate: true
  //   },
  // },
  mounted() {
    this.getBackground()
    this.setFontSize("Header", 226); // 更改ID为'Header'的元素的字体大小为20px
    this.getBanner();
  },
  methods: {
    setFontSize(elementId, size) {
      document.getElementById(
        elementId
      ).style.cssText = `font-size: ${size}px;`;
    },
    getBackground() {
      console.log(sessionStorage.getItem('__DSC_navTitle'))
    },
    getBannerName(id) {
      if (this.$store.getters.navTitle) {
        return this.$store.getters.navTitle
      } else {
        if (id) {
          switch (id) {
            case "idea":
              return "理念宗旨";
            case "os":
              return "组织架构";
            case "rules":
              return "工作守则";
            case "committee":
              return "委员会";
            case "list":
              return "专委新闻";
            case "notice":
              return "行业动态";
            case "policyNews":
              return "政策新闻";
            case "doc":
              return "知识专区";
            case "term":
              return "资料库";
            case "codePractice":
              return "数存百科";
            case "display":
              return "成员介绍";
            case "introduce":
              return "成员权益";
            case "rights":
              return "申请加入";
          }
        }
      }
    },
    more(item, id, nbId = "", isParam = false) {
      if (item.cClick == 0) return;
      if (item.cSign == 1 && item.cUrl) {
        window.open(item.cUrl, '_blank')
      } else {
        if (nbId) {
          if (isParam) {
            this.$router.push({
              path: "/news/list",
              query: { nbId: nbId, areaId: 3 },
            });
          } else {
            if (this.newsAction == 1) {
              this.$router.push({
                path: "/news/list",
                query: { nbId: nbId, areaId: 3 },
              });
            } else if (this.newsAction == 2) {
              this.$router.push({
                path: "/news/notice",
                query: { nbId: nbId, areaId: 4 },
              });
            } else {
              this.$router.push({
                path: "/news/policyNews",
                query: { nbId: nbId, areaId: 5 },
              });
            }
          }
        } else {
          this.$router.push({ path: id });
        }
      }
    },
    getBanner() {
      selectNoticeLarge().then((res) => {
        this.bannerList = res.data;
      });
    },
    goWarn() {
      this.$message({
        message: "功能正在建设中",
        type: "warning",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  background-size: cover;

  .header-content {
    width: 1280px;
    min-width: 1024px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: relative;

    .logo {
      width: 44.5%;
      .image {
        width: 100%;
      }
    }

    .login {
      height: 100%;
      a {
        display: inline-block;
        width: 110px;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        color: #fff;
        margin-left: 30px;

        &:nth-child(1) {
          background: #053780;
        }

        &:nth-child(2) {
          background: #f17b20;
        }
      }
    }

    .search {
      position: absolute;
      right: 0;
      color: #053780;
      font-size: 24px;
    }
  }

  .banner {
    width: 100%;
    min-width: 1280px;

    :deep(.el-carousel__indicators--horizontal) {
      height: 50px;
      display: flex;
      bottom: 28px;
    }
    :deep(.el-carousel__button) {
      width: 20px;
      height: 20px;
      margin: 0px 10px;
      border-radius: 50%;
    }

    .image {
      width: 100%;
      height: 520px;
      object-fit: cover;
    }
    .bannerTitle {
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 300px;
      font-size: 48px;
      font-weight: 700;
      color: #053780;
      span {
        position: relative;
        z-index: 10 !important;
        // margin-top: -54px;
      }
      .title-image {
        width: 69px;
        height: 48px;
        z-index: 8 !important;
        position: relative;
      }

      .left {
        right: -10px;
        top: -10px;
      }

      .right {
        left: -9px;
        bottom: -37px;
      }
    }
  }
  .s-banner{
    height: 300px;
    width: 100vw;
    background-color: #e5e7f4;
    .bannerTitle{
      // color: #ffffff;
      // text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.9);
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // span{
      //   margin-top: -54px;
      // }
    }
  }
}
</style>
